<template>
    <div class="feedback__item" :class="[ review.mark < 4 ? { feedback__item_bad: isBad } : {feedback__item_good: isGood }]">
        <div class="feedback__i-header">
            <div class="feedback__i-info">
                <img :src='review.anon ? "/media/patient_avatar.svg" : review.author.avatar' alt="#" class="avatar feedback__i-avatar">
                <div class="feedback__i-inner">
                    <span class="feedback__i-name">{{ review.anon ? 'Аноним' : review.author.name}}</span>
                    <time class="feedback__i-time">{{ convertDate(review.created_at) }}</time>
                </div>
            </div>
            <el-rate v-if="review.mark < 4"
                    :value="review.mark"
                    disabled-void-icon-class="icon-circle"
                    :disabled-void-color="badColor"
                    :icon-classes="iconClasses"
                    void-icon-class="icon-circle"
                    :void-color="badColor"
                    disabled
                    :colors="colors"
                    class="feedback__i-rate">
            </el-rate>
            <el-rate v-else
                    :value="review.mark"
                    disabled-void-icon-class="icon-circle"
                    :disabled-void-color="goodColor"
                    :icon-classes="iconClasses"
                    void-icon-class="icon-circle"
                    :void-color="goodColor"
                    disabled
                    :colors="colors"
                    class="feedback__i-rate">
            </el-rate>
        </div>
        <div class="feedback__i-text">
            <p>
                {{ review.description }}
            </p>
        </div>
        <div class="feedback__i-footer" v-if="user">
            <button v-if="show !== review.id" class="r-button feedback__i-answer" @click="showForm(review.id)">Ответить</button>
        </div>

        <form-comment v-if="show === review.id" :parentId='review.id'></form-comment>

        <comment v-for="comment in review.comments" :key="comment.id" v-if="review.comments.length" :comment="comment"></comment>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
    import FormComment from "./FormComment";
    import dayjs from "dayjs";
    import Comment from "./Comment";

    export default {
        name: "Answer",
        components: {Comment, FormComment},
        props: {
            review: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            can: true,
            iconClasses: ['icon-circle-back', 'icon-circle-back', 'icon-circle-back'],
            isBad: true,
            isGood: true,
            badColor: "#CC5D5D",
            goodColor: "#2A7FAC",
            colors: ["#CC5D5D", "#CC5D5D", "#2A7FAC"],
            value: 2,
            value_g: 4,
            open: false,
            open_g: true,
            user: window.laravel.user
        }),
        computed: {
            ...mapState([
                'show',
            ]),
            timezone() {
                return window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        methods: {
            ...mapMutations([
                'setShowForm',
                'clearArrayComment'
            ]),
            showForm(id) {
                this.clearArrayComment();
                this.setShowForm(id);
            },
            convertDate(date) {
                return dayjs.createFromTimezone(date, this.timezone).format('DD.MM.YYYY HH:mm');
            }
        }
    }
</script>
